import { render, staticRenderFns } from "./Reprocess.vue?vue&type=template&id=80bf8ac4&scoped=true&"
import script from "./Reprocess.vue?vue&type=script&lang=js&"
export * from "./Reprocess.vue?vue&type=script&lang=js&"
import style0 from "./Reprocess.vue?vue&type=style&index=0&id=80bf8ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf8ac4",
  null
  
)

export default component.exports